/**
 * Identificação do ambiente em que o bundle foi gerado.
 *
 * A flag vem de `REACT_APP_ENVIRONMENT`, declarada em cada arquivo `.env.*`
 */
export type Environment = "PRODUCAO" | "HOMOLOGACAO" | "DESENVOLVIMENTO" | "DESCONHECIDO";

interface IEnvironmentBadge {
    label: string;
    shortLabel: string;
    background: string;
    color: string;
}

/**
 * Fallback caso `REACT_APP_ENVIRONMENT` não esteja definida
 */
function inferFromTokenStorage(): Environment {
    const tokenStorage = (process.env.REACT_APP_API_SENSEDIA_TOKEN_STORAGE ?? "").toLowerCase();

    if (tokenStorage.includes("prd")) return "PRODUCAO";
    if (tokenStorage.includes("hml")) return "HOMOLOGACAO";
    if (tokenStorage.includes("dev")) return "DESENVOLVIMENTO";

    return "DESCONHECIDO";
}

function normalize(value: string): Environment {
    const normalized = value
        .normalize("NFD")
        .replace(/[̀-ͯ]/g, "")
        .trim()
        .toUpperCase();

    switch (normalized) {
        case "PRODUCAO":
        case "PRODUCTION":
        case "PRD":
            return "PRODUCAO";
        case "HOMOLOGACAO":
        case "HOMOLOG":
        case "STAGING":
        case "HMG":
        case "HML":
            return "HOMOLOGACAO";
        case "DESENVOLVIMENTO":
        case "DEVELOPMENT":
        case "DEV":
            return "DESENVOLVIMENTO";
        default:
            return "DESCONHECIDO";
    }
}

function resolveEnvironment(): Environment {
    const declared = process.env.REACT_APP_ENVIRONMENT ?? "";
    const resolved = declared ? normalize(declared) : "DESCONHECIDO";

    return resolved === "DESCONHECIDO" ? inferFromTokenStorage() : resolved;
}

export const environment: Environment = resolveEnvironment();

export const isProduction = environment === "PRODUCAO";

/** Dados Visuais do ambiente, para exibição em banner ou título da aba do navegador.*/
export const environmentBadge: IEnvironmentBadge | null = (() => {
    switch (environment) {
        case "HOMOLOGACAO":
            return {
                label: "Ambiente de Homologação",
                shortLabel: "HOMOLOGAÇÃO",
                background: "#C62828",
                color: "#FFFFFF",
            };
        case "DESENVOLVIMENTO":
            return {
                label: "Ambiente de Desenvolvimento",
                shortLabel: "DESENVOLVIMENTO",
                background: "#6A1B9A",
                color: "#FFFFFF",
            };
        default:
            return null;
    }
})();

/** Título da aba do navegador, prefixado com o ambiente fora de produção. */
export const documentTitle = environmentBadge
    ? `[${environmentBadge.shortLabel}] Pré-Billing`
    : "Pré-Billing";
